import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

const SEO = ({ 
  title, 
  description, 
  image, 
  url,
  businessName,
  tipedName,
  isBusiness = false,
  isTiped = false 
}) => {
  const { t, i18n } = useTranslation();
  const baseUrl = process.env.REACT_APP_WEB_URL || window.location.origin;
  const defaultImage = `${baseUrl}/logo.png`;
  const currentLang = i18n.language?.split('-')[0] || 'es';
  const isSpanish = currentLang === 'es';
  
  const defaultTitle = isSpanish
    ? 'Tipify - Deja tu propina de forma fácil y segura'
    : 'Tipify - Leave your tip easily and securely';
  const defaultDescription = isSpanish
    ? 'Plataforma digital para dejar propinas de forma rápida y segura. Apoya a tu equipo de servicio favorito.'
    : 'Digital platform to leave tips quickly and securely. Support your favorite service team.';

  // Construir título dinámico
  let finalTitle = defaultTitle;
  if (isBusiness && businessName) {
    finalTitle = isSpanish
      ? `Deja una propina a ${businessName} - Tipify`
      : `Leave a tip to ${businessName} - Tipify`;
  } else if (isTiped && tipedName) {
    finalTitle = isSpanish
      ? `Deja una propina a ${tipedName} - Tipify`
      : `Leave a tip to ${tipedName} - Tipify`;
  }

  // Construir descripción dinámica
  let finalDescription = defaultDescription;
  if (isBusiness && businessName) {
    finalDescription = isSpanish
      ? `Deja una propina a ${businessName} y apoya a su equipo. Fácil, rápido y seguro con Tipify.`
      : `Leave a tip to ${businessName} and support their team. Easy, fast and secure with Tipify.`;
  } else if (isTiped && tipedName) {
    finalDescription = isSpanish
      ? `Deja una propina directamente a ${tipedName}. Fácil, rápido y seguro con Tipify.`
      : `Leave a tip directly to ${tipedName}. Easy, fast and secure with Tipify.`;
  }

  const finalImage = image || defaultImage;
  const finalUrl = url || window.location.href;

  return (
    <Helmet>
      {/* Título básico */}
      <title>{title || finalTitle}</title>
      <meta name="description" content={description || finalDescription} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={finalUrl} />
      <meta property="og:title" content={title || finalTitle} />
      <meta property="og:description" content={description || finalDescription} />
      <meta property="og:image" content={finalImage} />
      <meta property="og:image:width" content="1721" />
      <meta property="og:image:height" content="507" />
      <meta property="og:image:alt" content="Tipify" />
      <meta property="og:site_name" content="Tipify" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={finalUrl} />
      <meta name="twitter:title" content={title || finalTitle} />
      <meta name="twitter:description" content={description || finalDescription} />
      <meta name="twitter:image" content={finalImage} />

      {/* Favicon */}
      <link rel="icon" type="image/png" href={`${baseUrl}/logo-small.png`} />
      <link rel="apple-touch-icon" href={`${baseUrl}/logo192.png`} />
    </Helmet>
  );
};

export default SEO;

